import arrayMove from 'array-move';
import { get } from 'lodash';
import React from 'react';
import { Input, OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import { DeleteIcon } from 'src/components/Icon';
import WarningIcon from 'src/components/Icon/Warning';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  ResponsiveAnimation,
  ResponsiveTabStyle,
} from 'src/components/Modules/Components';
import ModuleStyle from 'src/components/Modules/Components/ModuleStyle';
import Switcher from 'src/components/SectionSwitcher';
import {
  errKeys,
  generateResponsiveImage,
  generateTabPoster,
  responsivePosterTypeDict,
  tabErrorNameGenerator,
} from 'src/constrains/DraggableModules/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import {
  EModuleWidth,
  ENewTabLayerType,
  EResponsiveCarouselModuleSwitcherType,
  EResponsivePosterGap,
  EResponsivePosterType,
  EResponsiveResizingOption,
  EnumModuleType,
} from 'src/types/common/module';
import css from './css.module.less';

const Option = OriSelect.Option;

const ResponsivePosterTab = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    tabs,
    onItemAdd,
    onItemDelete,
    onItemChange,
    //onItemReselect,
    onItemSort,
    onStaticChange,
    onOpenNewTab,
    specificError,
    staticData,
    breakpoint,
    animations,
    hoverAnimations,
  } = props;
  //console.log('staticData', staticData);
  //console.log('specificErr', specificError);
  const isConvertible = breakpoint && breakpoint !== EPreviewSize.WIDE;
  const onlyLastTab = (tabs || []).length === 1;
  const draggableId = get(staticData, 'draggableId');
  //const posterType = get(staticData, 'posterType');
  const moduleWidth = get(staticData, 'moduleWidth');
  const posterGap = get(staticData, 'posterGap');
  const resizingOption = get(staticData, 'resizingOption');
  //const overflowOption = get(staticData, 'overflowOption');

  const moduleStyle = get(staticData, 'moduleStyle');
  const animation = get(staticData, 'animation');
  const tabStyle = get(staticData, 'tabStyle');

  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;
  const selectedTab = get(staticData, 'selectedTab');

  const shouldHideModuleBkgSetting =
    moduleWidth === EModuleWidth.NONE || moduleWidth === EModuleWidth.FULL;

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnGapChange = (posterGap) => {
    onStaticChange({ posterGap });
  };

  const handleOnResizingOptionChange = (resizingOption) => {
    onStaticChange({ resizingOption });
  };

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  //  const handleOnOverflowOptionChange = (overflowOption) => {
  //    onStaticChange({ overflowOption });
  //  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  const handleTabStyleChange = (tab) => {
    const newTabStyle = { ...(tabStyle || {}), ...tab };
    onStaticChange({ tabStyle: newTabStyle });
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onItemSort(oldIndex, newIndex);
  };

  const handleOnTabChange = (index, data) => {
    onItemChange(index, data);
  };

  const handleOnItemDelete = (index, draggableId) => {
    //selectedTab

    if (draggableId === selectedTab) {
      const newTabs = tabs.filter((i) => i.draggableId !== draggableId);

      if (newTabs.length > 0) {
        const newId = get(newTabs, '0.draggableId');

        onStaticChange({ selectedTab: newId });
      }
    }
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const handleOnPosterEdit = (tabId, id, data) => {
    //console.log(data);
    onOpenNewTab({
      imageId: id,
      contentListId: draggableId,
      data,
      type: ENewTabLayerType.Poster,
      additionalData: {
        sourceType: EnumModuleType.ResponsivePosterTab,
        tabId,
      },
    });
  };

  const handleOnItemAdd = () => {
    const data = generateTabPoster((tabs || []).length + 1);
    onItemAdd([data]);
    //
    if (!selectedTab) {
      const { draggableId } = data;
      onStaticChange({ selectedTab: draggableId });
    }
    //selectedTab
  };

  const handleOnPosterTabChange = (selectedTab) => {
    onStaticChange({ selectedTab });
  };

  //const handleOnPosterNameChange = () => {};

  // const hideGapLarge =
  //   isMobile || (isTablet && posterType === EResponsivePosterType.SIX);
  const childGenerate = (data, index) => {
    const { title, draggableId } = data;
    const nameErrK = errKeys.ResponsivePosterTab.tabName;
    const nameErr = specificError[`${draggableId}${nameErrK}`] || [];
    return (
      <div className={css.tabContainer}>
        <ItemWrapper
          size='small'
          titleClassName={css.titleContainer}
          title={
            <div className={css.titleTitleContainer}>
              {getI18n('general.tabTitle')}
              {!onlyLastTab && (
                <DeleteIcon
                  onDelete={() => {
                    // console.log('delete');
                    handleOnItemDelete(index, draggableId);
                  }}
                  //iconClassName={css.deleteIcon}
                />
              )}
            </div>
          }>
          <Input
            error={nameErr.length > 0}
            help={nameErr.join('')}
            size='large'
            maxLength={100}
            value={title}
            onChange={(title) => {
              onItemChange(index, { title });
            }}
          />
        </ItemWrapper>
      </div>
    );
  };

  const renderPosterGapType = () => {
    return [
      <Option value={EResponsivePosterGap.NONE} key={EResponsivePosterGap.NONE}>
        {getI18n('general.status.none')}
      </Option>,
      <Option
        value={EResponsivePosterGap.SMALL}
        key={EResponsivePosterGap.SMALL}>
        {getI18n('general.small')}
      </Option>,
      <Option
        value={EResponsivePosterGap.MIDDLE}
        key={EResponsivePosterGap.MIDDLE}>
        {getI18n('general.middle')}
      </Option>,
      <Option
        value={EResponsivePosterGap.LARGE}
        key={EResponsivePosterGap.LARGE}>
        {getI18n('general.lLarge')}
      </Option>,
    ];
  };

  return (
    <React.Fragment>
      {!isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper title={getI18n('general.moduleWidth')}>
            <OriSelect
              size='large'
              value={moduleWidth}
              onChange={handleOnModuleWidthChange}>
              <Option value={EModuleWidth.WIDE}>
                {getI18n('general.wideWidth')}
              </Option>
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            </OriSelect>
          </ItemWrapper>
        </Section>
      )}

      <Section size='small' bottomBorder>
        <ItemWrapper title={getI18n('general.gap')}>
          <OriSelect
            size='large'
            value={posterGap}
            onChange={handleOnGapChange}>
            {renderPosterGapType()}
          </OriSelect>
        </ItemWrapper>
        <ItemWrapper title={getI18n('general.responsiveResizingOption')}>
          <OriSelect
            size='large'
            value={resizingOption}
            onChange={handleOnResizingOptionChange}>
            <Option value={EResponsiveResizingOption.SCALABLE}>
              {getI18n('general.scaleHeightBasedOnModuleWidth')}
            </Option>
            <Option value={EResponsiveResizingOption.FIXED}>
              {getI18n('general.fixedHeight')}
            </Option>
          </OriSelect>
        </ItemWrapper>
      </Section>
      <Section size='small' className={css.switcherContainer} bottomBorder>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ModuleStyle
                    hideBkgConfig={shouldHideModuleBkgSetting}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                    isMobileOrTablet={isConvertible}
                  />
                </div>
              ),
            },
            ...(isConvertible
              ? {}
              : {
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                }),

            [EResponsiveCarouselModuleSwitcherType.TabStyle]: {
              title: getI18n('general.tabStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ResponsiveTabStyle
                    data={tabStyle}
                    onChange={handleTabStyleChange}
                    isConvertible={isConvertible}
                  />
                </div>
              ),
            },
            //
          }}
        />
      </Section>
      {!isConvertible && (
        <DragNDropColumns
          // disabled={!isPrimary}
          // hideAdd={!isPrimary}
          // hideTitle
          titleRightTextClassName={css.tabAddText}
          title={getI18n('general.allTabs')}
          childGenerate={childGenerate}
          data={tabs || []}
          droppableId={`salesChannelContentListPosterTab${draggableId}`}
          onSort={handleItemOnSort}
          hideAdd={true}
          titleRightText={`+ ${getI18n('general.addTab')}`}
          titleRightFunction={handleOnItemAdd}
        />
      )}

      {tabs && tabs.length > 0 && (
        <Section size='small' className={css.switcherContainer}>
          <Switcher
            selectContainer={css.switcher}
            selected={selectedTab}
            onChange={handleOnPosterTabChange}
            allSections={tabs.reduce((pre, now, index) => {
              const { draggableId: dId, title, posters } = now;
              let hasError = false;
              posters.forEach((poster) => {
                const { draggableId: posterId } = poster;
                const imgErrK = errKeys.ResponsivePosterTab.image;
                const k = tabErrorNameGenerator(dId, posterId, imgErrK);
                const err = specificError[k] || [];
                if (err.length > 0) {
                  hasError = true;
                }
              });
              const relatedErr = Object.keys(specificError).reduce(
                (pre, now) => {
                  if (now.startsWith(dId)) {
                    return { ...pre, [now]: specificError[now] };
                  }
                  return pre;
                },
                {},
              );
              // console.log('relatedErr', relatedErr);
              return {
                ...pre,
                [dId]: {
                  title: title,
                  hasError: hasError,
                  child: (
                    <Poster
                      isConvertible={isConvertible}
                      // hasError={hasError}
                      data={now}
                      draggableId={dId}
                      specificError={relatedErr}
                      onChange={(data) => {
                        // const _posters = get(now, 'posters') || [];
                        // _posters.splice(index, 1, poster);
                        handleOnTabChange(index, data);
                      }}
                      onEdit={(id, data) => {
                        handleOnPosterEdit(dId, id, data);
                      }}
                    />
                  ),
                },
              };
            }, {})}
          />
        </Section>
      )}
    </React.Fragment>
  );
};

export default ResponsivePosterTab;

// const Animation = (props) => {
//   const { data, onChange, animations } = props;
//   const _animations = [
//     { value: null, label: 'None' },
//     ...(animations || []).map((i) => {
//       const { name, uuid } = i;
//       return { label: name, value: uuid };
//     }),
//   ];
//   const entranceUuid = get(data, 'entranceUuid') || null;
//   const hoverEffectUuid = get(data, 'hoverEffectUuid') || null;
//   return (
//     <React.Fragment>
//       <ItemWrapper size='small' title='Entrance Animation'>
//         <OriSelect
//           size='large'
//           value={entranceUuid}
//           onChange={(entranceUuid) => {
//             onChange({ entranceUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//       <ItemWrapper size='small' title='Hover Effect'>
//         <OriSelect
//           size='large'
//           value={hoverEffectUuid}
//           onChange={(hoverEffectUuid) => {
//             onChange({ hoverEffectUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//     </React.Fragment>
//   );
// };

const Poster = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, draggableId, onEdit, specificError, isConvertible } =
    props;
  const { posterType, posters } = data || {};
  const handleOnPosterTypeChange = (posterType) => {
    const currentShouldHave = responsivePosterTypeDict[posterType] || 1;
    const currentHave = (posters || []).length;
    if (currentShouldHave > currentHave) {
      const diff = currentShouldHave - currentHave;
      const _new = [];
      for (let i = 0; i < diff; i++) {
        const index = i + currentHave + 1;
        _new.push(generateResponsiveImage(`Poster ${index}`));
      }
      const _posters = [...(posters || []), ..._new];
      const _data = { posterType, posters: _posters };
      onChange(_data);
    } else if (currentShouldHave < currentHave) {
      const _posters = posters.slice(0, currentShouldHave);
      const _data = { posterType, posters: _posters };
      onChange(_data);
    } else {
      onChange({ posterType });
    }
  };

  const renderPosterType = () => {
    //isTablet
    return [
      <Option key={EResponsivePosterType.ONE} value={EResponsivePosterType.ONE}>
        {getI18n('general.onePoster')}
      </Option>,
      <Option
        key={EResponsivePosterType.TWO_1_1}
        value={EResponsivePosterType.TWO_1_1}>
        {getI18n('general.twoInOne')} (1:1)
      </Option>,
      <Option
        key={EResponsivePosterType.TWO_1_2}
        value={EResponsivePosterType.TWO_1_2}>
        {getI18n('general.twoInOne')} (1:2)
      </Option>,
      <Option
        key={EResponsivePosterType.TWO_2_1}
        value={EResponsivePosterType.TWO_2_1}>
        {getI18n('general.twoInOne')} (2:1)
      </Option>,
      <Option
        key={EResponsivePosterType.THREE}
        value={EResponsivePosterType.THREE}>
        {getI18n('general.threeInOne')}
      </Option>,
      <Option
        key={EResponsivePosterType.FOUR}
        value={EResponsivePosterType.FOUR}>
        {getI18n('general.fourInOne')}
      </Option>,
      <Option
        key={EResponsivePosterType.FIVE}
        value={EResponsivePosterType.FIVE}>
        {getI18n('general.fiveInOne')}
      </Option>,
      <Option key={EResponsivePosterType.SIX} value={EResponsivePosterType.SIX}>
        {getI18n('general.sixInOne')}
      </Option>,
    ];
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    const _posters = arrayMove(posters, oldIndex, newIndex);
    //const _data = { ...data, posters: _posters };
    onChange({ posters: _posters });
    // onChange(oldIndex, newIndex);
  };

  const childGenerate = (data, index) => {
    const { draggableId: dId, name } = data;
    //specificError
    const imgErrK = errKeys.ResponsivePosterTab.image;
    const k = tabErrorNameGenerator(draggableId, dId, imgErrK);

    const hasError = (specificError[k] || []).length > 0;
    return (
      <TextAndEditIcon
        additional={
          hasError ? (
            <div className={css.errorIconContainer}>
              <WarningIcon />
            </div>
          ) : null
        }
        containerClassName={css.containerClassName}
        name={name}
        onClick={() => {
          onEdit(dId, data);
          //if (onEdit) onEdit(draggableId, data);
        }}
      />
    );
  };

  return (
    <React.Fragment>
      {/* <Section size='small' bottomBorder> */}
      {!isConvertible && (
        <Section size='small' bottomBorder className={css.posterContainer}>
          <ItemWrapper title={getI18n('general.posterType')}>
            <OriSelect
              value={posterType}
              size='large'
              onChange={handleOnPosterTypeChange}>
              {renderPosterType()}
            </OriSelect>
          </ItemWrapper>
        </Section>
      )}

      {/* </Section> */}
      <DragNDropColumns
        // disabled={!isPrimary}
        // hideAdd={!isPrimary}
        disabled={isConvertible}
        hideTitle
        childGenerate={childGenerate}
        data={posters || []}
        droppableId={`salesChannelContentListPosterTabPoster${draggableId}`}
        onSort={handleItemOnSort}
        hideAdd={true}
      />
    </React.Fragment>
  );
};
